import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Users } from "lucide-react";
import { COLLABS, waLink } from "@/data/site";
import { SectionHeading } from "@/components/pp/Shared";
import { track } from "@/lib/api";

const COLORS = ["#f59e0b", "#ec4899", "#8b5cf6"];

export default function Collaborations() {
  return (
    <section className="relative py-24 md:py-32" data-testid="collaborations">
      <div className="pp-container">
        <SectionHeading overline="Collaborations" title="Influence Meets Creative Direction"
          sub="From creator discovery to campaign production, PixelPapad coordinates collaboration strategy, creative direction and campaign execution." testid="collabs-heading" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {COLLABS.map((c, i) => (
            <motion.div key={c.title}
              initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.1 }}
              className="group relative pp-card rounded-2xl p-8 min-h-[280px] flex flex-col justify-between overflow-hidden"
              data-testid={`collab-${c.title.replace(/\s+/g, '-').toLowerCase()}`}
            >
              {/* abstract silhouette */}
              <div className="absolute -bottom-8 -right-4 opacity-20 group-hover:opacity-40 transition-opacity">
                <Users size={140} style={{ color: COLORS[i] }} />
              </div>
              <span className="h-12 w-12 rounded-full grid place-items-center text-black font-display text-xl relative z-[1]"
                style={{ background: COLORS[i] }}>{i + 1}</span>
              <div className="relative z-[1]">
                <h3 className="font-display uppercase text-2xl md:text-3xl text-white">{c.title}</h3>
                <p className="mt-2 text-sm text-slate-400 max-w-[85%]">{c.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-10">
          <a href={waLink("Hi PixelPapad, I'd like to discuss a collaboration campaign.")} target="_blank" rel="noopener noreferrer"
            onClick={() => track("whatsapp_click", { location: "collaborations" })}
            data-testid="collab-cta"
            className="inline-flex items-center gap-2 bg-[#f59e0b] text-black font-semibold uppercase tracking-widest text-xs px-7 py-4 hover:bg-white transition-colors">
            Discuss a Collaboration <ArrowRight size={16} />
          </a>
          <p className="mt-4 text-[11px] uppercase tracking-widest text-slate-600">Abstract graphics used until authorised photographs are supplied.</p>
        </div>
      </div>
    </section>
  );
}
